<template>
  <div class="requisition-documents-container">
    <div class="mb-3">
      <em class="icon-shadowed fas fa-file text-orange" />
      <span class="color-gray-7 font-16 font-weight-bold ml-2 mb-2">
        Documentos de la Requisición
      </span>
    </div>
    <div v-if="hasDocuments">
      <div
        v-for="(item, key) in item.documents"
        :key="key"
        class="p-3 my-3 bg-white rounded border-left-2"
      >
        <div class="row d-flex align-items-center px-3 ">
          <div class="col-md-5 col-sm-12">
            <div class="color-secondary-6 font-14">
              Nombre del Documento:
            </div>
            <div>
              {{ item.title | empty }}
            </div>
          </div>
          <div class="col-md-5 col-sm-12">
            <div class="color-secondary-6 font-14">
              Archivo:
            </div>
            <div>
              {{ item.fileName | empty }}
            </div>
          </div>
          <div class="col-md col-sm-12 d-flex justify-content-end">
            <action-button
              variant="success"
              class="text-white"
              i="fa fa-file-download fa-lg"
              @click="donwloadDocument(item.id)"
            />
          </div>
        </div>
      </div>
    </div>
    <custom-result-not-found
      v-else
      text="No hay documentos asociados a la Requisición"
    />
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import CustomResultNotFound from 'custom-result-not-found';

import apiService from '@/services/api/requisitionmanagment.api';
import documentsService from '@/services/api/document.api';

export default {
  name: 'RequisitionDocuments',
  components: {
    ActionButton,
    IconView,
    CustomResultNotFound,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    id() {
      return this.item.id;
    },
    hasDocuments() {
      return Boolean(this.item.documents.length);
    },
  },
  async mounted() {
    await this.getDocuments();
  },
  methods: {
    async getDocuments() {
      if (this.hasDocuments) return;
      const { data } = await apiService.getRequisitionDocuments(this.id);
      this.item.documents = data;
    },
    async donwloadDocument(id) {
      await documentsService.downloadFromServer(id);
    },
  },
};
</script>
<style lang="scss" scoped>
.requisition-documents-container i.fas.fa-file {
  height: 30px;
  width: 30px;
}
.border-left-2 {
  border-left-style: solid;
  border-left-width: 4px;
  border-left-color: #d9e5df;
}
</style>
